module.exports = __webpack_public_path__ + "static/google-7804fff69fe9d522e31c8a5a24a0b683.jpg";